import { createReducer, on } from '@ngrx/store';
import { SettingsState, UserType } from '@wam/shared';
import { determineUserType } from '@app/authentication/user.data';
import { isReportsApp } from '@app/reports-app/reports-app.util';
import { getSettings } from '../settings.data';
import { setRegistryDataForService } from './settings.actions';

/**
 * The standalone reports app can share an origin (e.g. `localhost`) with the teacher/admin apps,
 * so a stale `userType=ADMIN` left in `localStorage` by an earlier admin session must not be
 * honored here. `determineUserType()` always resolves to `TEACHER` for the reports app (and
 * refreshes `localStorage` to match), so route through it unconditionally in that case instead of
 * falling back to it only when nothing is persisted yet.
 */
function resolveUserType(): UserType {
  if (isReportsApp()) {
    return determineUserType();
  }

  return UserType[localStorage.getItem('userType')] || determineUserType();
}

const initialState: SettingsState = {
  settings: getSettings(),
  registryRecords: null,
  userType: resolveUserType(),
};

const settingsReducer = createReducer(
  initialState,
  on(setRegistryDataForService, (state, registryRecords) => ({
    ...state,
    registryRecords,
  })),
);

export function reducer(state, action) {
  return settingsReducer(state, action);
}
